import { deleteApiCaller, getApiCaller, postApiCaller, postFormDataApiCaller, putApiCaller, putFormDataApiCaller } from "../apiCaller";

// Get all home section categories
export const getHomeSectionCategories = async (page = 1, limit = 10, search = '', tree = false, parentId = null) => {
  let url = `homeSection-category/get-all?page=${page}&limit=${limit}&includeHidden=true`;

  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }

  if (tree) {
    url += `&tree=true`;
  }

  if (parentId !== null) {
    url += `&parentId=${parentId}`;
  }

  const response = await getApiCaller(url);
  return response;
};

// Get home section categories dropdown (for parent selection)
export const getHomeSectionCategoriesDropdown = async () => {
  const response = await getApiCaller("homeSection-category/dropdown");
  return response;
};

// Get home section category by ID
export const getHomeSectionCategoryById = async (id) => {
  const response = await getApiCaller(`homeSection-category/${id}`);
  return response;
};

// Get home sections by category ID
export const getHomeSectionsByCategoryId = async (categoryId, page = 1, limit = 10) => {
  const response = await getApiCaller(`homeSection-category/${categoryId}/content?page=${page}&limit=${limit}&includeHidden=true`);
  return response;
};

// Get category children
export const getHomeSectionCategoryChildren = async (categoryId) => {
  const response = await getApiCaller(`homeSection-category/${categoryId}/children`);
  return response;
};

// Get category ancestors (breadcrumb)
export const getHomeSectionCategoryAncestors = async (categoryId) => {
  const response = await getApiCaller(`homeSection-category/${categoryId}/ancestors`);
  return response;
};

// Add home section category
export const addHomeSectionCategory = async (payload) => {
  const response = await postFormDataApiCaller("homeSection-category/create", payload);
  return response;
};

// Update home section category
export const updateHomeSectionCategory = async (id, payload) => {
  const response = await putFormDataApiCaller(`homeSection-category/update/${id}`, payload);
  return response;
};

// Delete home section category
export const deleteHomeSectionCategory = async (id, homeSectionAction = null, targetCategoryId = null) => {
  const body = homeSectionAction ? { homeSectionAction, targetCategoryId } : null;
  const response = await deleteApiCaller(`homeSection-category/delete/${id}`, body);
  return response;
};

// Update category sequence
export const homeSectionCategorySequence = async (payload) => {
  const response = await putApiCaller("homeSection-category/sequence", payload);
  return response;
};

// Swap category with adjacent page
export const swapHomeSectionCategoryWithPage = async (payload) => {
  const response = await putApiCaller("homeSection-category/swap-page", payload);
  return response;
};

// YouTube Playlist Preview
export const previewYouTubePlaylist = async (payload) => {
  const response = await postApiCaller("homeSection-category/youtube/preview", payload);
  return response;
};

// YouTube Playlist Import
export const importYouTubePlaylist = async (payload) => {
  const response = await postApiCaller("homeSection-category/youtube/import", payload);
  return response;
};
